export type PasswordRule = {
  text: string;
  valid: (password: string) => boolean;
};

export const defaultRules: PasswordRule[] = [
  {
    text: 'One lowercase character',
    valid: (password) => !!password.match(/[a-z]/),
  },
  {
    text: 'One uppercase character',
    valid: (password) => !!password.match(/[A-Z]/),
  },
  {
    text: 'One number',
    valid: (password) => !!password.match(/[0-9]/),
  },
  {
    text: 'One symbol',
    valid: (password) => !!password.match(/[!@#$%^&*()-=_+[\]{};':",./<>?]/),
  },
  {
    text: `8 characters minimum`,
    valid: (password) => password.length >= 8,
  },
];

export const passwordValid = (password: string, rules: PasswordRule[] = defaultRules): boolean => {
  return rules.every((rule) => rule.valid(password));
};
